import Chart from 'chart.js'
import { colors } from '../functions.js'
// eslint-disable-next-line
import chartjsPluginAnnotation from 'chartjs-plugin-annotation'

// eslint-disable-next-line
function getToday () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    var yyyy = today.getFullYear()
    var d = yyyy + '-' + mm + '-' + dd
    today = new Date(d)
    today = today.toString().split(' ')
    today = today[1] + ' ' + today[2]
    return today
}

// eslint-disable-next-line
Date.prototype.getWeek = function () {
    var onejan = new Date(this.getFullYear(), 0, 1)
    return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7)
}

function geYearWeek () {
    var today = new Date()
    let week = today.getWeek()
    let year = today.getFullYear()
    return year + '-W' + week
}

function hexToRgbA (hex, opacity) {
    var c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    } else { return hex }
}

export default class ChartClass {
    constructor (ctx, labels, data, scaleData, type = 'line', lineToday = false) {
        const datasets = ChartClass.handleData(data)
        const scales = ChartClass.handleScales(scaleData)
        let annotation = {}
        if (lineToday === true) {
            annotation =
            {
                drawTime: 'afterDatasetsDraw',
                annotations: [{
                    type: 'line',
                    mode: 'Vertical',
                    scaleID: 'X',
                    value: geYearWeek(),
                    borderColor: '#E35500',
                    borderWidth: 2,
                    borderDash: [5, 10],
                    label: {
                        display: false
                    }
                }]
            }
        }
        this.chart = new Chart(ctx, {
            type: type,
            data: {
                datasets,
                labels
            },
            options: {
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true
                },
                tooltips: {
                    enabled: true
                },
                scales: {
                    xAxes: scales.xAxes,
                    yAxes: scales.yAxes
                },
                annotation: annotation
            }
        })
    }
    static handleData (data) {
        return data.map((item, index) => {
            return {
                type: item.type,
                yAxisID: item.yAxisID,
                label: item.label,
                data: item.data,
                fill: 'fill' in item ? item.fill : true,
                backgroundColor: 'backgroundColor' in item ? hexToRgbA(item.backgroundColor, 0.3) : hexToRgbA(colors[index], 0.3),
                borderColor: 'borderColor' in item ? hexToRgbA(item.borderColor, 1) : hexToRgbA(colors[index], 1),
                borderWidth: 2,
                lineTension: 'lineTension' in item ? item.lineTension : 0.4,
                radius: 'radius' in item ? item.radius : 0,
                borderDash: 'borderDash' in item ? item.borderDash : [0, 0]
            }
        })
    }

    static handleScales (scales) {
        let returnData = { 'yAxes': [], 'xAxes': [] }
        for (let y of scales.yAxes) {
            let ax = {
                id: y.id,
                stacked: y.stacked,
                position: y.position,
                scaleLabel: {
                    display: true,
                    labelString: y.label,
                    fontSize: 14
                },
                gridLines: {
                    display: false
                },
                ticks: {
                    fontSize: 14,
                    min: 'min' in y ? y.min : 0
                }
            }
            returnData['yAxes'].push(ax)
        }
        let ax = {
            id: 'X',
            stacked: scales.xAxes.stacked,
            scaleLabel: {
                display: true,
                labelString: scales.xAxes.label,
                fontSize: 14
            },
            gridLines: {
                display: false
            },
            ticks: {
                fontSize: 14,
                beginAtZero: true,
                userCallback: function (item, index) {
                    if (!(index % 0)) return item
                }
            }
        }
        returnData['xAxes'].push(ax)

        return returnData
    }

    update (labels, data, type) {
        this.chart.type = type
        this.chart.data.labels = labels
        this.chart.data.datasets = ChartClass.handleData(data)
        this.chart.update()
    }

    delete () {
        this.chart.destroy()
    }
}
